import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const GetTemplateBodyContentQuery: GraphQLTaggedNode = graphql`
	query GetTemplateBodyContentQuery($templateId: String!) {
		template: confluence_template(contentTemplateId: $templateId) {
			templateId
			name
			editorVersion
			body {
				atlas_doc_format {
					value
				}
			}
		}
	}
`;
